import { replay } from './fsrs.js';

const CHUNK = 400;

/**
 * Rebuild the cached (device-local) schedule of cards from their review logs.
 * Only touches local fields, so it never creates sync traffic.
 */
export async function recomputeCards(db, cardIds) {
  const ids = [...new Set(cardIds)].filter(Boolean);
  for (let i = 0; i < ids.length; i += CHUNK) {
    const chunk = ids.slice(i, i + CHUNK);
    const cards = (await db.cards.bulkGet(chunk)).filter(Boolean);
    if (!cards.length) continue;
    const deckIds = [...new Set(cards.map((c) => c.deckId))];
    const decks = await db.decks.bulkGet(deckIds);
    const configs = new Map(decks.filter(Boolean).map((d) => [d.id, d.config]));
    const logs = await db.reviewLogs.where('cardId').anyOf(chunk).toArray();
    const byCard = new Map();
    for (const l of logs) {
      if (!byCard.has(l.cardId)) byCard.set(l.cardId, []);
      byCard.get(l.cardId).push(l);
    }
    await db.transaction('rw', db.cards, async () => {
      for (const card of cards) {
        const s = replay(card, byCard.get(card.id) ?? [], configs.get(card.deckId));
        await db.cards.update(card.id, s);
      }
    });
  }
}

export async function recomputeDecks(db, deckIds) {
  if (!deckIds.length) return;
  const ids = await db.cards.where('deckId').anyOf([...new Set(deckIds)]).primaryKeys();
  await recomputeCards(db, ids);
}

export async function recomputeAll(db) {
  await recomputeCards(db, await db.cards.toCollection().primaryKeys());
}
